import styled from 'styled-components';
export const Container = styled.li `
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.12px;
    align-items: flex-start;
`;
export const Header = styled.div `
    display: flex;
    width: 100%;
    flex-direction: row;
    border: 0 solid #797979;
    border-bottom-width: 1px;
    padding: 16px 0;
    box-sizing: border-box;
    align-items: center;
`;
export const OptionsContainer = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
`;
//# sourceMappingURL=index.js.map